import { SvgIcon, SvgIconProps } from '@mui/material';
import { memo } from 'react';
const SvgMenuAndroid32 = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <path
        d="M16 12c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
        className="menu-android-32_svg__path-1"
      />
    </SvgIcon>
  );
};
const Memo = memo(SvgMenuAndroid32);
export default Memo;
